import { render } from "./CreateTaskModalStandalone.vue?vue&type=template&id=75dc78a8&scoped=true"
import script from "./CreateTaskModalStandalone.vue?vue&type=script&lang=js"
export * from "./CreateTaskModalStandalone.vue?vue&type=script&lang=js"

import "./CreateTaskModalStandalone.vue?vue&type=style&index=0&id=75dc78a8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-75dc78a8"

export default script